import { useCallback, useState } from 'react';

/**
 *
 * A state hook to either set some value as the selected value
 * or, if it was the selected value, deselect the value.
 *
 * Example:
 * const colors = ['red', 'green', 'blue']
 * const [selectedColor, setSelectedColor] = useSelectedValue(colors[0])
 *
 * // selectedColor is red
 *
 * setSelectedColor(colors[1])
 * // selectedColor is green
 *
 * setSelectedColor(colors[2])
 * // selectedColor is blue
 *
 * setSelectedColor(colors[2])
 * // selectedColor is undefined
 *
 */
const useSelectedValue = (initialSelectedValue: unknown) => {
  const [selected, setState] = useState(initialSelectedValue);
  const setSelected = useCallback(
    (value: unknown) =>
      setState((curSelected: unknown) =>
        curSelected === value ? undefined : value,
      ),
    [],
  );
  return [selected, setSelected] as const;
};

export default useSelectedValue;
